import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverPerformanceEntity } from '../../domain/entities/DriverPerformanceEntity'

export class DriverPerformanceModel extends DriverPerformanceEntity {
  constructor(dataDto: DriverPerformanceModel) {
    super()
    mapEntityProperties<DriverPerformanceEntity>(this, dataDto)
  }
}
